import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// ProgressBar / ProgressRing — индикаторы прогресса загрузки (из форка «Наш.Чат», DLP-5).
// value 0..1 — определённый прогресс; undefined — «бегущая» полоса / вращающаяся дуга (сколько всего,
// неизвестно). Презентационные: только отображение, на токенах темы. Анимации — через keyframes,
// инжектируемые один раз (как у Spinner), чтобы примитив работал и без глобальных стилей кита.
import { useEffect } from 'react';
const KEYFRAMES_ID = 'tc-ds-progress-keyframes';
function ensureKeyframes() {
    if (typeof document === 'undefined')
        return;
    if (document.getElementById(KEYFRAMES_ID))
        return;
    const style = document.createElement('style');
    style.id = KEYFRAMES_ID;
    style.textContent =
        '@keyframes tc-ds-progress-run{0%{transform:translateX(-100%)}100%{transform:translateX(250%)}}' +
            '@keyframes tc-ds-progress-spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}';
    document.head.appendChild(style);
}
/** 0..1 → целый процент 0..100 (мусор → 0). */
export function progressPercent(value) {
    if (!Number.isFinite(value))
        return 0;
    return Math.round(Math.min(1, Math.max(0, value)) * 100);
}
export function ProgressBar({ value, height = 4, inverse = false, label = 'Загрузка', style }) {
    useEffect(ensureKeyframes, []);
    const determinate = value !== undefined;
    const pct = determinate ? progressPercent(value) : undefined;
    const track = {
        position: 'relative',
        display: 'block',
        width: '100%',
        height: `${height}px`,
        overflow: 'hidden',
        borderRadius: `${height}px`,
        background: inverse ? 'rgba(255,255,255,0.28)' : 'var(--color-divider)',
        ...style,
    };
    const bar = {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        borderRadius: 'inherit',
        background: inverse ? 'var(--color-text-inverse)' : 'var(--color-accent)',
        ...(determinate
            ? { width: `${pct}%`, transition: 'width 160ms linear' }
            : { width: '40%', animation: 'tc-ds-progress-run 1.1s ease-in-out infinite' }),
    };
    return (_jsx("span", { role: "progressbar", "aria-label": label, "aria-valuemin": 0, "aria-valuemax": 100, ...(pct !== undefined ? { 'aria-valuenow': pct } : {}), "data-progress-bar": "", "data-value": pct, style: track, children: _jsx("span", { style: bar }, determinate ? 'determinate' : 'running') }));
}
export function ProgressRing({ value, size = 40, thickness = 3, color = 'var(--color-accent)', trackColor = 'var(--color-divider)', label = 'Загрузка', children, style, }) {
    useEffect(ensureKeyframes, []);
    const determinate = value !== undefined;
    const pct = determinate ? progressPercent(value) : undefined;
    const r = (size - thickness) / 2;
    const circumference = 2 * Math.PI * r;
    const dash = determinate ? (circumference * (pct ?? 0)) / 100 : circumference * 0.28;
    return (_jsxs("span", { role: "progressbar", "aria-label": label, "aria-valuemin": 0, "aria-valuemax": 100, ...(pct !== undefined ? { 'aria-valuenow': pct } : {}), "data-progress-ring": "", "data-value": pct, style: {
            position: 'relative',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: `${size}px`,
            height: `${size}px`,
            flex: '0 0 auto',
            ...style,
        }, children: [_jsxs("svg", { width: size, height: size, viewBox: `0 0 ${size} ${size}`, "aria-hidden": true, style: {
                    position: 'absolute',
                    inset: 0,
                    transform: determinate ? 'rotate(-90deg)' : undefined,
                    animation: determinate ? undefined : 'tc-ds-progress-spin 0.9s linear infinite',
                }, children: [_jsx("circle", { cx: size / 2, cy: size / 2, r: r, fill: "none", stroke: trackColor, strokeWidth: thickness }), _jsx("circle", { cx: size / 2, cy: size / 2, r: r, fill: "none", stroke: color, strokeWidth: thickness, strokeLinecap: "round", strokeDasharray: `${dash} ${circumference}`, style: { transition: determinate ? 'stroke-dasharray 160ms linear' : undefined } })] }), children !== undefined ? (_jsx("span", { style: { position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }, children: children })) : null] }));
}
//# sourceMappingURL=Progress.js.map